import { format } from "date-fns";

export class AnalyticsDataModel {
    constructor(

        public startDate: string,
        public endDate: string

    ) {

        this.startDate = startDate;
        this.endDate = endDate;
    }
    static init = () =>
        new AnalyticsDataModel(
            format(new Date(), "MM/dd/yyyy"),
            format(new Date(), "MM/dd/yyyy")
        );
}